module.exports = __webpack_public_path__ + "static/img/product2.63a20f7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product2.jpg
// module id = sjfD
// module chunks = 0